export default __webpack_public_path__ + "static/media/logo.870b9b38.png";